.hstack {
  display: flex;
  gap: var(--spacing-04);
}

.hstack.sm {
  gap: var(--spacing-02);
}

.hstack.lg {
  gap: var(--spacing-06);
}

.hstack.xl {
  gap: var(--spacing-09);
}

.hstack.xxl {
  gap: var(--spacing-10);
}
